(function () {
  angular.module('MktzapApp.Directives')
	 .directive('hsmManipulate', hsmManipulate);

	 hsmManipulate.inject = ['LangService']

  function hsmManipulate (LangService) {
    var vm = this;
    return {
      // replace:true,
      restrict: 'AE',
      scope: {
        varsCollection: '=',
        mailingCollection: '=',
        hsmTemplate: '=',
        ngModel: '='
      },
      require: 'ngModel',
      templateUrl: baseUrl + '/templates/common/hsm_template.html',
      link: function ($scope, elem, attr, ctrl) {
        LangService
          .getPageLabels({ 'page': 'menu.att.all' })
          .$promise
          .then(function (data) {
            $scope.labelsPage = vm.labelsPage = data.lang
          })

        // Dados dos ngModel dos campos dos forms
        $scope.formData = {};

        // Definições por função
        $scope.themeDefinitions = {
          medium: '24',
          typeHSM: 'Ativo'
        };

        var modelViewValue = {}
        $scope.isValidForm = false
        // Validar se existe o tipo para executar as funções
        if (attr.hasOwnProperty('type')) {
          $scope.hsmTemplate = $scope.hsmTemplate;
          $scope.themeDefinitions.fields = extractVars($scope.hsmTemplate);
          $scope.themeDefinitions.customCss = true
          // Ativo de camapanha
						 if (attr.type === 'many' || attr.type === 'campaign') {
							 $scope.themeDefinitions.medium = '12'
							 $scope.themeDefinitions.customCss = false
							 $scope.themeDefinitions.typeHSM = 'Campanha'
							 $scope.fieldTemplateColumns = {}

            if (($scope.hasOwnProperty('mailingCollection') && $scope.mailingCollection != null)) {
              $scope.themeDefinitions.mailingCollection = $scope.mailingCollection
              $scope.themeDefinitions.mailingCollection.push('Outro');
            }
          }

          if ($scope.ngModel != null) {
            var keys = Object.keys($scope.ngModel);
            var itensReplace = ['[', ']']
            angular.forEach(keys, function (value) {
              var viewValue = $scope.ngModel[value].key;
              angular.forEach(itensReplace, function (replace) {
                viewValue = viewValue.replace(replace, '')
              })
              $scope.formData[value] = {};
              if ($scope.ngModel[value].type == 'custom') {
                $scope.formData[value].value = 'Outro';
                $scope.formData[value].Customvalue = viewValue;
                $scope.fieldTemplateColumns[value] = { hasExtras: { enabled: true }, extraIndex: value }
                replaceValues(attr.type, viewValue, $scope.formData)
              } else {
                $scope.formData[value].value = viewValue;
                replaceValues(attr.type, viewValue, $scope.formData)
              }
            })
          }

          $scope.themeDefinitions.type = attr.type
        }

        // private functions
        function mountedFormData () {
          angular.forEach($scope.themeDefinitions.fields, function (value) {
            $scope.formData[value] = '';
          })
          ctrl.$setViewValue($scope.formData)
        }

        function onChangeTextArea (type) {
          ctrl.$setViewValue(null)
          ctrl.$modelValue = null
          ctrl.$viewValue = null
          if (!$scope.hsmTemplate) {
            modelViewValue = {}
            $scope.hsmTemplateReplaced = null
            $scope.formData = {}
            return
          }

          $scope.hsmTemplate = $scope.hsmTemplate;
          $scope.hsmTemplateReplaced = $scope.hsmTemplate
          $scope.formData = {};
          $scope.themeDefinitions.fields = extractVars($scope.hsmTemplate);
          // Ativo de camapanha
						 if (type === 'many' || type === 'campaign') {
							 $scope.themeDefinitions.medium = '12'
							 $scope.themeDefinitions.typeHSM = 'Campanha'
							 $scope.fieldTemplateColumns = {}

            if (($scope.hasOwnProperty('mailingCollection') && $scope.mailingCollection != null)) {
              $scope.themeDefinitions.mailingCollection = $scope.mailingCollection
              if ($scope.themeDefinitions.mailingCollection.indexOf('Outro') === -1) {
                $scope.themeDefinitions.mailingCollection.push('Outro');
              }
            }
          }
        }

        function extractVars (template) {
          if (template) {
            var regex = /\{{+[^\}]+\}}+/gm;
            return template.match(regex)
          }
        }

        function replaceValuesCampaign (fullParams) {
          if (!$scope.hsmTemplate) return;

          $scope.hsmTemplateReplaced = $scope.hsmTemplate;
          angular.forEach(fullParams, function (key, index) {
            var replaceValue = key.value;

            if (replaceValue == undefined) {
              replaceValue = '';
            }
            var hsmPayload = { 'type': 'mailing', 'key': replaceValue };

            if (hsmPayload.key === null || hsmPayload.key === undefined) {
              $scope.fieldTemplateColumns[index] = { hasExtras: { enabled: false }, extraIndex: index }
              return buildViewValue(index, hsmPayload)
            }

            if (replaceValue != undefined) {
              hsmPayload.key = replaceValue;
              if (replaceValue.toUpperCase() === 'OUTRO') {
                $scope.fieldTemplateColumns[index] = { hasExtras: { enabled: true }, extraIndex: index }
                if (!key.Customvalue) {
                  key.Customvalue = ''
                  hsmPayload.type = 'custom'
                  hsmPayload.key = '';
                  return buildViewValue(index, hsmPayload)
                }

                replaceValue = key.Customvalue;
                hsmPayload.type = 'custom';
                hsmPayload.key = replaceValue;
              } else if ($scope.fieldTemplateColumns[index] && replaceValue.toUpperCase() != 'OUTRO') {
                $scope.fieldTemplateColumns[index] = { hasExtras: { enabled: false }, extraIndex: index }
                key.Customvalue = ''
              }

              if (!$scope.hsmTemplateReplaced) {
                $scope.hsmTemplateReplaced = $scope.hsmTemplate.replace(index, replaceValue);
              } else {
                if ($scope.hsmTemplateReplaced.indexOf(index) > -1) {
                  $scope.hsmTemplateReplaced = $scope.hsmTemplateReplaced.replace(index, replaceValue);
                } else {
                  $scope.hsmTemplateReplaced = $scope.hsmTemplate.replace(index, replaceValue);
                }
              }
              buildViewValue(index, hsmPayload)
            }
          })
        }
        function replaceValuesActive (fullParams) {
          angular.forEach(fullParams, function (key, index) {
            var replaceValue = key.value;

            if (replaceValue == undefined) {
              replaceValue = '';
            }
            if (!$scope.hsmTemplateReplaced) {
              $scope.hsmTemplateReplaced = $scope.hsmTemplate.replace(index, replaceValue);
            } else {
              if ($scope.hsmTemplateReplaced.indexOf(index) > -1) {
                $scope.hsmTemplateReplaced = $scope.hsmTemplateReplaced.replace(index, replaceValue);
              } else {
                $scope.hsmTemplateReplaced = $scope.hsmTemplate.replace(index, replaceValue);
              }
            }
            buildViewValue(index, replaceValue)
          })
        }

        function buildViewValue (variable, value) {
          modelViewValue[variable] = value;
          ctrl.$setViewValue(modelViewValue)
        }
        function replaceValues (type, indexedValues, fullParams) {
          if (type === 'many') {
            replaceValuesCampaign(fullParams);
          }
          if (type === 'one') {
            replaceValuesActive(fullParams);
          }
        }

        function clearReplaceValues () {
          $scope.hsmTemplateReplaced = null;
          $scope.formData = {};
        }

        var unWatch_hsmTemplate = $scope.$watch('hsmTemplate', function (newValue, oldValue) {
          if (newValue != '' && (newValue != oldValue)) {
            onChangeTextArea($scope.themeDefinitions.type)
            mountedFormData();
          } else if (newValue === '') {
            $scope.hsmTemplate = null;
            onChangeTextArea($scope.themeDefinitions.type)
          }
        });

        var unWatch_Mailing = $scope.$watch('mailingCollection', function (newValue, oldValue) {
          if (newValue != oldValue) {
            if (($scope.hsmTemplate && $scope.themeDefinitions.mailingCollection) && (newValue != undefined || newValue != null)) {
              $scope.themeDefinitions.fields = extractVars($scope.hsmTemplate);
              $scope.themeDefinitions.mailingCollection = newValue;
              if ($scope.themeDefinitions.mailingCollection.indexOf('Outro') === -1) {
                $scope.themeDefinitions.mailingCollection.push('Outro');
              }
              setTimeout(() => {
                $scope.$apply();
              }, 3000);
            }
          }
        });

        $scope.$on('$destroy', function () {
          unWatch_hsmTemplate();
          unWatch_Mailing();
        });

        $scope.FindAndReplaceValues = replaceValues;
        $scope.clearReplaceValues = clearReplaceValues;
      }
    }
  }
})();
